import { render, staticRenderFns } from "./MarkItems.vue?vue&type=template&id=2b44bbd6"
import script from "./MarkItems.vue?vue&type=script&lang=js"
export * from "./MarkItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports